/**
 * Auth-page inline icons — no icon-kit dependency. Every glyph is `stroke="currentColor"`,
 * `aria-hidden` (decoration only; the accessible name lives on the parent control/label), and sizes
 * via a shared base so the auth surfaces stay visually consistent. RTL-mirroring (e.g. the back
 * chevron) is handled in CSS, not here.
 */
import type { SVGProps } from "react";

const BASE: SVGProps<SVGSVGElement> = {
  width: 16,
  height: 16,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
  focusable: false,
};

export function EyeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...BASE} {...props}>
      <path d="M1.5 12S5 5 12 5s10.5 7 10.5 7-3.5 7-10.5 7S1.5 12 1.5 12z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

export function EyeOffIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...BASE} {...props}>
      <path d="M9.9 5.2A10.4 10.4 0 0 1 12 5c7 0 10.5 7 10.5 7a18 18 0 0 1-3.3 4.1M6.3 6.7A18 18 0 0 0 1.5 12S5 19 12 19a10.3 10.3 0 0 0 4.1-.8" />
      <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
      <path d="M3 3l18 18" />
    </svg>
  );
}

export function LockIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...BASE} width={13} height={13} {...props}>
      <rect x="4" y="11" width="16" height="10" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </svg>
  );
}

export function MailIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...BASE} {...props}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 7l9 6 9-6" />
    </svg>
  );
}

export function ChevronBackIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...BASE} width={15} height={15} {...props}>
      <path d="M15 18l-6-6 6-6" />
    </svg>
  );
}

export function CheckIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...BASE} {...props}>
      <path d="M20 6L9 17l-5-5" />
    </svg>
  );
}

export function DotIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...BASE} {...props}>
      <circle cx="12" cy="12" r="3.5" />
    </svg>
  );
}

export function AlertIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...BASE} {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 8v5M12 16.5h.01" />
    </svg>
  );
}

export function InfoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...BASE} {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5M12 7.5h.01" />
    </svg>
  );
}

export function MailBigIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...BASE} width={26} height={26} {...props}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 7l9 6 9-6" />
    </svg>
  );
}

export function CheckBigIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...BASE} width={26} height={26} {...props}>
      <path d="M20 6L9 17l-5-5" />
    </svg>
  );
}
